import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { API_ENDPOINT } from '../shared/Constant/constant';
import { SearchRequest } from '../shared/models/searchRequest';
import { NotificationResource } from '..//shared/models/notificationResource';

/**
 * Servicio para manejar las búsquedas de productos.
 */
@Injectable({
  providedIn: 'root'
})
export class SearchedProductService {

  public baseUrl = environment.apiUrl;
  private apiUrl = `${this.baseUrl}${API_ENDPOINT.SEARCHS}`;


  constructor(private http: HttpClient) { }

  /**
   * Envía una nueva búsqueda de producto al backend.
   * Corresponde al endpoint POST /api/v1/search/product.
   * @param searchRequest El objeto que contiene el término de búsqueda y el ID de usuario.
   * @returns Un Observable con la respuesta de notificación del servidor.
   */
  handleProductSearch(searchRequest: SearchRequest): Observable<NotificationResource> {
    const url = `${this.apiUrl}/product`;
    return this.http.post<NotificationResource>(url, searchRequest).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Manejo de errores centralizado para las solicitudes HTTP.
   * @param error El error HTTP.
   * @returns Un Observable con el error.
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ocurrió un error desconocido al enviar la búsqueda.';
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente o de red.
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // El backend devolvió un código de respuesta fallido.
      errorMessage = `Código de error del backend: ${error.status}, cuerpo: ${error.error}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
